import { BULK_DOWNLOAD_ARCHIVE_BATCH_SETTINGS, BULK_ENGINE_STATE, DASHBOARD_EMAIL_NOTIFICATION_SETTINGS, LOCALSTORAGE_DASHBOARD_AGGREGATE_KEY, LOCALSTORAGE_DASHBOARD_CAPTURED_BY_PROJECTS_KEY, LOCALSTORAGE_DASHBOARD_ISSUED_BY_PROJECTS_KEY, LOCALSTORAGE_DASHBOARD_PAYMENTS_MADE_PROJECTS_KEY, LOCALSTORAGE_DASHBOARD_PRINTED_BY_PROJECTS_KEY, LOCALSTORAGE_DASHBOARD_STAT_DATA_KEY, LOCALSTORAGE_LINK_PROJECT_CODE, LOCALSTORAGE_LINK_PROJECT_ROLE_TYPE, LOCALSTORAGE_LINK_PROJECT_ROLE_TYPE_CONFIG, LOCALSTORAGE_LINK_PROJECT_USER_DATA, LOCALSTORAGE_LINK_PROJECT_USER_REG, LOCALSTORAGE_ORGANIZATIONS_KEY, LOCALSTORAGE_PROJECT_ID_CARD_ARTIFACT_KEY, LOCALSTORAGE_USER_ACCOUNT_SETUP_DETAILS_KEY, LOCALSTORAGE_USER_AUTHORIZATION_DETAILS_KEY, LOCALSTORAGE_USER_ID_KEY, STAFF_BIO_DATA, STAFF_FAILED_FACE_MATCH, STAFF_FAILED_NIN, STAFF_PHOTO_RETAKE_ACTION, STUDENT_FAILED_FACE_MATCH, STUDENT_FAILED_NIN } from './../shared/model/app';
import { Injectable } from '@angular/core';

import { IAccountInterface, IBaseContext, IContextData } from '../shared/model/config';
import {
  LOCALSTORAGE_BASE_SETTING_KEY,
  LOCALSTORAGE_SIGNUP_SETTING_KEY,
  LOCALSTORAGE_TRANSLATION_KEY,
  LOCALSTORAGE_BILLABLE_INFO_KEY,
  LOCALSTORAGE_USER_TIMEOUT_INFO_KEY,
  LOCALSTORAGE_CREDENTIAL_KEY,
  LOCALSTORAGE_TOKEN_KEY,
  LOCALSTORAGE_SIGNUP_DETAILS_KEY,
  LOCALSTORAGE_SIGNUP_ORG_DETAILS_KEY,
  LOCALSTORAGE_RETURL_URL,
  LOCALSTORAGE_CURRENT_CONTEXT_KEY,
  LOCALSTORAGE_ALL_CATEGORY_KEY,
  LOCALSTORAGE_CURRENT_CATEGORY_KEY,
  LOCALSTORAGE_CONTEXT_ID_KEY,
  LOCALSTORAGE_BASE_CONTEXT_DATA_KEY,
  LOCALSTORAGE_PRODUCT_ID_KEY,
  LOCALSTORAGE_THEME,
  LOCALSTORAGE_SRM_ID_KEY,
  LOCALSTORAGE_APP_DEFAULT_THEME,
  LOCALSTORAGE_USER_ALLOWED_TIME,
  LOCALSTORAGE_LINK_PROJECT_CONFIG,
  LOCALSTORAGE_PROJECT_ID_KEY,
  LOCALSTORAGE_COMPANY_ID_KEY,
  LOCALSTORAGE_LINK_PROJECT_RECEIPT_DATA,
  STUDENT_BIO_DATA,
} from '../shared/model/app';
import { PRODUCT_ID } from '../util/constant';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  getBaseSettings(): { [key: string]: any } {
    const baseSettings = window.localStorage.getItem(LOCALSTORAGE_BASE_SETTING_KEY);
    if (baseSettings) {
      return JSON.parse(baseSettings);
    }
    return {};
  }

  setBaseSettings(settings: { [key: string]: any }) {
    window.localStorage.setItem(LOCALSTORAGE_BASE_SETTING_KEY, JSON.stringify(settings));
  }

  setSignUpSettings(settings: any) {
    window.localStorage.setItem(LOCALSTORAGE_SIGNUP_SETTING_KEY, JSON.stringify(settings));
  }

  setBillableInfo(data: { [key: string]: any }) {
    window.localStorage.setItem(LOCALSTORAGE_BILLABLE_INFO_KEY, JSON.stringify(data));
  }

  setUserAllowedTimeStamp(userTimeStamp: { allowedTime: number }) {
    window.localStorage.setItem(LOCALSTORAGE_USER_ALLOWED_TIME, JSON.stringify(userTimeStamp));
  }

  getUserAllowedTimeStamp() {
    const userTimeStamp = window.localStorage.getItem(LOCALSTORAGE_USER_ALLOWED_TIME);
    if (userTimeStamp) {
      return JSON.parse(userTimeStamp);
    }
    return null;
  }

  setUserTimeOut(timeOut: { [key: string]: any }) {
    window.localStorage.setItem(LOCALSTORAGE_USER_TIMEOUT_INFO_KEY, JSON.stringify(timeOut));
  }

  getUserTimeOut() {
    const userTimeOut = window.localStorage.getItem(LOCALSTORAGE_USER_TIMEOUT_INFO_KEY);
    if (userTimeOut) {
      return JSON.parse(userTimeOut);
    }
    return null;
  }

  removeUserTimeOut(): void {
    return window.localStorage.removeItem(LOCALSTORAGE_USER_TIMEOUT_INFO_KEY);
  }

  getSignUpSettings() {
    const signupSettings = window.localStorage.getItem(LOCALSTORAGE_SIGNUP_SETTING_KEY);
    if (signupSettings) {
      return JSON.parse(signupSettings);
    }
    return null;
  }

  getBillableInfo() {
    const billableInfo = JSON.parse(window.localStorage.getItem(LOCALSTORAGE_BILLABLE_INFO_KEY));
    return billableInfo;
  }

  getSignUpSetting(param: string) {
    let settings = this.getSignUpSettings();
    if (settings) {
      let data = settings.find((setting) => setting.name.toLowerCase() == param.toLowerCase());
      return data;
    }
    return null;
  }

  getTranslationLang(): string | null {
    return window.localStorage.getItem(LOCALSTORAGE_TRANSLATION_KEY);
  }

  static setTranslationLang(language: string): void {
    return window.localStorage.setItem(LOCALSTORAGE_TRANSLATION_KEY, language);
  }

  setUserCredential(credential: any): void {
    return window.localStorage.setItem(LOCALSTORAGE_CREDENTIAL_KEY, JSON.stringify(credential));
  }

  updateUserCredential({ portrait, ...userData }: any): void {
    const credential = this.getUserUserCredential();
    if (credential.user) {
      credential.user = { ...credential.user, ...userData };
      this.setUserCredential(credential);
    }
  }

  getUserUserCredential(): any {
    return {
      user: {
        id: "53de4080-2b7c-48cf-96f3-c65b0a832288",
        orgId: "5d288066-4378-46b3-8ed3-f6656b7c0603",
        email: "olamideajaja@yopmail.com",
        firstName: "Olamide",
        lastName: "Ajah",
        superAdmin: true
      }
    }
  }

  getUserUserPrivileges(): Array<string> {
    const credential = this.getUserUserCredential();
    if (credential && credential.privileges) {
      return credential.privileges;
    } else {
      return [];
    }
  }

  logOut(): void {
    window.localStorage.removeItem('user-credential');
    window.localStorage.removeItem('auth-token');
    window.localStorage.removeItem(LOCALSTORAGE_BASE_CONTEXT_DATA_KEY);
    window.localStorage.removeItem(LOCALSTORAGE_CURRENT_CATEGORY_KEY);
    window.localStorage.removeItem(LOCALSTORAGE_CURRENT_CONTEXT_KEY);
    window.localStorage.removeItem(LOCALSTORAGE_ALL_CATEGORY_KEY);
    window.localStorage.removeItem(LOCALSTORAGE_CONTEXT_ID_KEY);
    window.localStorage.removeItem(LOCALSTORAGE_THEME);
  }

  setReturnUrl(url) {
    window.localStorage.setItem(LOCALSTORAGE_RETURL_URL, url);
  }

  getAuthUserToken() {
    return JSON.parse(window.localStorage.getItem(LOCALSTORAGE_TOKEN_KEY));
  }

  setAuthUserToken(token: string): void {
    window.localStorage.setItem(LOCALSTORAGE_TOKEN_KEY, JSON.stringify(token));
  }

  getUserBranch(): string | null {
    const contextData = this.getContextData();

    if (contextData.branch) {
      return contextData.branch;
    }
    return null;
  }

  getUserOrg(): string | null {
    const contextData = this.getContextData();

    if (contextData.organization) {
      return contextData.organization;
    }
    return null;
  }

  getUserType(): string | null {
    const contextData = this.getContextData();

    if (contextData.userType) {
      return contextData.userType;
    }
    return null;
  }

  getProductUserUserCategoryId(): string | null {
    const contextData = this.getContextData();

    if (contextData.productUserCategoryBaseId) {
      return contextData.productUserCategoryBaseId;
    }
    return null;
  }

  getProductUserCategoryCode(): string | null {
    const contextData = this.getContextData();

    if (contextData.productUserCategoryBaseCode) {
      return contextData.productUserCategoryBaseCode;
    }
    return null;
  }

  getProductUserCategoryName(): string | null {
    const contextData = this.getContextData();

    if (contextData.productUserCategoryName) {
      return contextData.productUserCategoryName;
    }
    return null;
  }

  isUserOrgIdAvailable(): boolean {
    if (this.getUserOrg()) {
      return true;
    } else {
      return false;
    }
  }

  getUserEmail(): string | null {
    const userData = this.getUserUserCredential();
    if (userData && userData.user) {
      return userData.user.email;
    }
    return '';
  }

  getUserFullname(): string | null {
    const userData = this.getUserUserCredential();
    if (userData && userData.user) {
      return `${userData.user.firstName ? userData.user.firstName + ' ' : ''}${userData.user.lastName || ''}`;
    }
    return '';
  }

  getUserLogo(): string | null {
    const userData = this.getUserUserCredential();
    if (userData && userData.user) {
      return userData.user.portrait;
    }
    return null;
  }

  getSignUpDetails() {
    if (window.localStorage.getItem(LOCALSTORAGE_SIGNUP_DETAILS_KEY)) {
      return JSON.parse(window.localStorage.getItem(LOCALSTORAGE_SIGNUP_DETAILS_KEY));
    }
    return null;
  }

  setSignUpDetails(data) {
    window.localStorage.setItem(LOCALSTORAGE_SIGNUP_DETAILS_KEY, JSON.stringify(data));
  }
  clearSignUpDetails() {
    window.localStorage.removeItem(LOCALSTORAGE_SIGNUP_DETAILS_KEY);
  }

  getOrganisationList() {
    return JSON.parse(window.localStorage.getItem(LOCALSTORAGE_ORGANIZATIONS_KEY));
  }

  setOrganisationList(data) {
    window.localStorage.setItem(LOCALSTORAGE_ORGANIZATIONS_KEY, JSON.stringify(data));
  }

  getOrganisationSignUpDetails() {
    return JSON.parse(window.localStorage.getItem(LOCALSTORAGE_SIGNUP_ORG_DETAILS_KEY));
  }

  setOrganisationSignUpDetails(data) {
    window.localStorage.setItem(LOCALSTORAGE_SIGNUP_ORG_DETAILS_KEY, JSON.stringify(data));
  }

  isSuperAdmin(): boolean | null {
    const userData = this.getUserUserCredential();
    if (userData && userData.user) {
      return userData.user.superAdmin;
    }
    return false;
  }

  setUserPrivileges(newPrivileges: Array<string> = []): void {
    const credential = this.getUserUserCredential();
    if (credential) {
      this.setUserCredential({ ...credential, privileges: newPrivileges });
    }
  }

  getCurrentContext(): IBaseContext | null {
    const context = window.localStorage.getItem(LOCALSTORAGE_CURRENT_CONTEXT_KEY);

    if (context) {
      return JSON.parse(context);
    } else {
      return null;
    }
  }

  getUserContextId(): string | null {
    const contextId = window.localStorage.getItem(LOCALSTORAGE_CONTEXT_ID_KEY);

    if (contextId) {
      return contextId;
    } else {
      return null;
    }
  }

  setUserContextId(contextId: string): void | null {
    window.localStorage.setItem(LOCALSTORAGE_CONTEXT_ID_KEY, contextId);
  }

  removeContextId() {
    window.localStorage.removeItem(LOCALSTORAGE_CONTEXT_ID_KEY);
  }

  getSRMId(): string | null {
    const contextId = window.localStorage.getItem(LOCALSTORAGE_SRM_ID_KEY);

    if (contextId) {
      return contextId;
    } else {
      return null;
    }
  }

  setSRMId(contextId: string): void | null {
    window.localStorage.setItem(LOCALSTORAGE_SRM_ID_KEY, contextId);
  }

  removeSRMId() {
    window.localStorage.removeItem(LOCALSTORAGE_SRM_ID_KEY);
  }

  getContextData(): IContextData {
    const data = JSON.parse(window.localStorage.getItem(LOCALSTORAGE_BASE_CONTEXT_DATA_KEY));

    if (data) {
      return data;
    } else {
      return {};
    }
  }

  isUserSignedIn(): boolean {
    return this.getAuthUserToken() && this.getUserUserCredential().user;
  }

  setAllCategory(category: Array<IAccountInterface>): void {
    window.localStorage.setItem(LOCALSTORAGE_ALL_CATEGORY_KEY, JSON.stringify(category));
  }

  setCurrentCategory(category: IAccountInterface): void {
    window.localStorage.setItem(LOCALSTORAGE_CURRENT_CATEGORY_KEY, JSON.stringify(category));
  }

  setCurrentContext(context: IBaseContext, privileges: Array<string>): void {
    window.localStorage.setItem(LOCALSTORAGE_CURRENT_CONTEXT_KEY, JSON.stringify(context));
    //Update user privilege
    this.setUserPrivileges(privileges);
  }

  getAllCategories(): Array<IAccountInterface> | null {
    const categories = window.localStorage.getItem(LOCALSTORAGE_ALL_CATEGORY_KEY);

    if (categories) {
      return JSON.parse(categories);
    } else {
      return null;
    }
  }

  getCurrentCategory(): IAccountInterface | null {
    const category = window.localStorage.getItem(LOCALSTORAGE_CURRENT_CATEGORY_KEY);

    if (category) {
      return JSON.parse(category);
    } else {
      return null;
    }
  }

  getProductId(): string | null {
    return window.localStorage.getItem(LOCALSTORAGE_PRODUCT_ID_KEY);
  }

  setProductId(productId: string): void {
    window.localStorage.setItem(LOCALSTORAGE_PRODUCT_ID_KEY, productId);
  }

  getFormCaptureExternalLinkHeaders(): any {
    const userToken = this.getAuthUserToken();
    let language = this.getTranslationLang();
    let orgId = this.getUserOrg();
    let branchId = this.getUserBranch();
    let productUserUserCategoryId = this.getProductUserUserCategoryId();
    let productUserUserCategoryCode = this.getProductUserCategoryCode();
    let userType = this.getUserType();
    let productId = this.getProductId() || PRODUCT_ID;

    return {
      'Accept-Language': `${language || ''}`,
      Authorization: userToken ? `Bearer ${userToken}` : '',
      'Base-Product': productId || '',
      'Base-Org': orgId || '',
      'Base-Branch': branchId || '',
      'Base-Product-user-category-id': productUserUserCategoryId || '',
      'Base-Product-user-category-code': productUserUserCategoryCode || '',
      'Base-User-type': userType || '',
    };
  }

  setTheme(theme) {
    window.localStorage.setItem(LOCALSTORAGE_THEME, JSON.stringify(theme));
  }


  getTheme() {
    let theme = window.localStorage.getItem(LOCALSTORAGE_THEME);
    if (theme) {
      return JSON.parse(theme);
    }
    return null;
  }


  clearTheme() {
    window.localStorage.removeItem(LOCALSTORAGE_THEME);
  }

  getPrimaryColor() {
    let theme = this.getTheme();
    if (theme && theme['primary-color']) {
      return theme['primary-color'];
    }
    return this.getDefaultPrimaryColor();
  }

  getDefaultPrimaryColor() {
    let theme = this.getDefaultTheme();
    if (theme && theme['primary-color']) {
      return theme['primary-color'];
    }

    return null;
  }

  getDefaultLogo() {
    let theme = this.getDefaultTheme();
    if (theme && theme['logo']) {
      return 'data:image/jpeg;base64,' + theme['logo'];
    }
    return null;
  }

  getLogo() {
    let theme = this.getTheme();
    if (theme && theme['logo']) {
      return 'data:image/jpeg;base64,' + theme['logo'];
    }
    return this.getDefaultLogo();
  }

  setDefaultTheme(theme) {
    window.localStorage.setItem(LOCALSTORAGE_APP_DEFAULT_THEME, JSON.stringify(theme));
  }

  getDefaultTheme() {
    const theme = window.localStorage.getItem(LOCALSTORAGE_APP_DEFAULT_THEME);
    if (theme) {
      return JSON.parse(theme);
    }
    return null;
  }

  getLinkProjectConfig(): { [key: string]: any } {
    const projectConfig = window.localStorage.getItem(LOCALSTORAGE_LINK_PROJECT_CONFIG);
    if (typeof projectConfig !== 'string') {
      return JSON.parse(projectConfig);
    }
    return {};
  }

  setLinkProjectConfig(config: { [key: string]: any }) {
    window.localStorage.setItem(LOCALSTORAGE_LINK_PROJECT_CONFIG, JSON.stringify(config));
  }

  removeLinkProjectConfig() {
    window.localStorage.removeItem(LOCALSTORAGE_LINK_PROJECT_CONFIG);
  }

  getLinkProjectLogo() {
    const config = this.getLinkProjectConfig();
    if (config && config['logo']) {
      return 'data:image/jpeg;base64,' + config['logo'];
    }
    return this.getDefaultLogo();
  }

  setLinkProjectRoleTypeConfig(data) {
    window.localStorage.setItem(LOCALSTORAGE_LINK_PROJECT_ROLE_TYPE_CONFIG, JSON.stringify(data));
  }

  getLinkProjectRoleTypeConfig() {
    const config = window.localStorage.getItem(LOCALSTORAGE_LINK_PROJECT_ROLE_TYPE_CONFIG);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  removeLinkProjectRoleTypeConfig() {
    window.localStorage.removeItem(LOCALSTORAGE_LINK_PROJECT_ROLE_TYPE_CONFIG);
  }

  setLinkProjectRoleType(data) {
    window.localStorage.setItem(LOCALSTORAGE_LINK_PROJECT_ROLE_TYPE, JSON.stringify(data));
  }

  getLinkProjectRoleType() {
    const config = window.localStorage.getItem(LOCALSTORAGE_LINK_PROJECT_ROLE_TYPE);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  removeRoleType() {
    window.localStorage.removeItem(LOCALSTORAGE_LINK_PROJECT_ROLE_TYPE);
    window.localStorage.removeItem(LOCALSTORAGE_LINK_PROJECT_ROLE_TYPE_CONFIG);
  }

  setLinkProjectCode(data) {
    window.localStorage.setItem(LOCALSTORAGE_LINK_PROJECT_CODE, JSON.stringify(data));
  }

  getLinkProjectCode() {
    const config = window.localStorage.getItem(LOCALSTORAGE_LINK_PROJECT_CODE);

    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  removeLinkProjectCode() {
    window.localStorage.removeItem(LOCALSTORAGE_LINK_PROJECT_CODE);
  }

  setLinkProjectUserData(data) {
    window.localStorage.setItem(LOCALSTORAGE_LINK_PROJECT_USER_DATA, JSON.stringify(data));
  }

  getLinkProjectUserData() {
    const config = window.localStorage.getItem(LOCALSTORAGE_LINK_PROJECT_USER_DATA);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  removeLinkProjectUserData(): void {
    window.localStorage.removeItem(LOCALSTORAGE_LINK_PROJECT_USER_DATA);
  }

  setLinkProjectUserReg(data) {
    window.localStorage.setItem(LOCALSTORAGE_LINK_PROJECT_USER_REG, JSON.stringify(data));
  }

  setLinkProjectReceiptData(data) {
    window.localStorage.setItem(LOCALSTORAGE_LINK_PROJECT_RECEIPT_DATA, JSON.stringify(data));
  }

  removeLinkProjectReceiptData(): void {
    window.localStorage.removeItem(LOCALSTORAGE_LINK_PROJECT_RECEIPT_DATA);
  }

  getLinkProjectReceiptData() {
    const config = window.localStorage.getItem(LOCALSTORAGE_LINK_PROJECT_RECEIPT_DATA);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  getLinkProjectUserReg() {
    const config = window.localStorage.getItem(LOCALSTORAGE_LINK_PROJECT_USER_REG);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  clearStorage() {
    window.localStorage.clear();
  }

  removeLinkDataFromStore() {
    window.localStorage.removeItem(LOCALSTORAGE_LINK_PROJECT_USER_DATA);
    window.localStorage.removeItem(LOCALSTORAGE_LINK_PROJECT_USER_REG);
    window.localStorage.removeItem(LOCALSTORAGE_LINK_PROJECT_CODE);
    window.localStorage.removeItem(LOCALSTORAGE_LINK_PROJECT_CONFIG);
    window.localStorage.removeItem(LOCALSTORAGE_LINK_PROJECT_ROLE_TYPE);
    window.localStorage.removeItem(LOCALSTORAGE_LINK_PROJECT_ROLE_TYPE_CONFIG);
  }

  getProjectId(): string | null {
    return window.localStorage.getItem(LOCALSTORAGE_PROJECT_ID_KEY);
  }

  setProjectId(projectId: string): void {
    window.localStorage.setItem(LOCALSTORAGE_PROJECT_ID_KEY, projectId);
  }

  getProjectIdCardArtifact(): string | null {
    const config = window.localStorage.getItem(LOCALSTORAGE_PROJECT_ID_CARD_ARTIFACT_KEY);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setProjectIdCardArtifact(data: any): void {
    window.localStorage.setItem(LOCALSTORAGE_PROJECT_ID_CARD_ARTIFACT_KEY, JSON.stringify(data));
  }

  removeProjectIdCardArtifact(): void {
    window.localStorage.removeItem(LOCALSTORAGE_PROJECT_ID_CARD_ARTIFACT_KEY);
  }

  removeProjectId() {
    window.localStorage.removeItem(LOCALSTORAGE_PROJECT_ID_KEY);
  }

  getCompanyId(): string | null {
    return window.localStorage.getItem(LOCALSTORAGE_COMPANY_ID_KEY);
  }

  setCompanyId(companyId: string): void {
    window.localStorage.setItem(LOCALSTORAGE_COMPANY_ID_KEY, companyId);
  }

  removeCompanyId() {
    window.localStorage.removeItem(LOCALSTORAGE_COMPANY_ID_KEY);
  }

  setStudentBioData(data) {
    window.localStorage.setItem(STUDENT_BIO_DATA, JSON.stringify(data));
  }

  removeStudentBioData() {
    window.localStorage.removeItem(STUDENT_BIO_DATA);
  }

  getStudentBioData() {
    const config = window.localStorage.getItem(STUDENT_BIO_DATA);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setStaffBioData(data) {
    window.localStorage.setItem(STAFF_BIO_DATA, JSON.stringify(data));
  }

  removeStaffBioData() {
    window.localStorage.removeItem(STAFF_BIO_DATA);
  }

  getStaffBioData() {
    const config = window.localStorage.getItem(STAFF_BIO_DATA);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setStaffPhotoRetakeAction(state: any) {
    window.localStorage.setItem(STAFF_PHOTO_RETAKE_ACTION, state);
  }

  getStaffPhotoRetakeAction() {
    const config = JSON.parse(window.localStorage.getItem(STAFF_PHOTO_RETAKE_ACTION));
    return config;
  }

  removeStaffPhotoRetakeAction() {
    window.localStorage.removeItem(STAFF_PHOTO_RETAKE_ACTION);
  }



  getUserId(): string | null {
    return window.localStorage.getItem(LOCALSTORAGE_USER_ID_KEY);
  }

  setUserId(userId: string): void {
    window.localStorage.setItem(LOCALSTORAGE_USER_ID_KEY, userId);
  }

  removeUserId() {
    window.localStorage.removeItem(LOCALSTORAGE_USER_ID_KEY);
  }


  setStudentFailedNin(data) {
    window.localStorage.setItem(STUDENT_FAILED_NIN, JSON.stringify(data));
  }

  getStudentFailedNin() {
    const config = window.localStorage.getItem(STUDENT_FAILED_NIN);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }


  setStudentFailedFaceMatch(data) {
    window.localStorage.setItem(STUDENT_FAILED_FACE_MATCH, JSON.stringify(data));
  }

  getStudentFailedFaceMatch() {
    const config = window.localStorage.getItem(STUDENT_FAILED_FACE_MATCH);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }


  setStudentNinVerificationCount(data) {
    window.localStorage.setItem(STUDENT_FAILED_FACE_MATCH, JSON.stringify(data));
  }

  getStudentNinVerificationCount() {
    const config = window.localStorage.getItem(STUDENT_FAILED_FACE_MATCH);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }


  setStudentFaceMatchCount(data) {
    window.localStorage.setItem(STUDENT_FAILED_FACE_MATCH, JSON.stringify(data));
  }

  getStudentFaceMatchCount() {
    const config = window.localStorage.getItem(STUDENT_FAILED_FACE_MATCH);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }




  setStaffFailedNin(data) {
    window.localStorage.setItem(STAFF_FAILED_NIN, JSON.stringify(data));
  }

  getStaffFailedNin() {
    const config = window.localStorage.getItem(STAFF_FAILED_NIN);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setStaffFailedFaceMatch(data) {
    window.localStorage.setItem(STAFF_FAILED_FACE_MATCH, JSON.stringify(data));
  }

  getStaffFailedFaceMatch() {
    const config = window.localStorage.getItem(STAFF_FAILED_FACE_MATCH);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setStaffNinVerificationCount(data) {
    window.localStorage.setItem(STAFF_FAILED_FACE_MATCH, JSON.stringify(data));
  }

  getStaffNinVerificationCount() {
    const config = window.localStorage.getItem(STAFF_FAILED_FACE_MATCH);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setStaffFaceMatchCount(data) {
    window.localStorage.setItem(STAFF_FAILED_FACE_MATCH, JSON.stringify(data));
  }

  getStaffFaceMatchCount() {
    const config = window.localStorage.getItem(STAFF_FAILED_FACE_MATCH);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  getUserAccountSetupDetails(): any | null {
    const config = window.localStorage.getItem(LOCALSTORAGE_USER_ACCOUNT_SETUP_DETAILS_KEY);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setUserAccountSetupDetails(data: any): void {
    window.localStorage.setItem(LOCALSTORAGE_USER_ACCOUNT_SETUP_DETAILS_KEY, JSON.stringify(data));
  }

  removeUserAccountSetupDetails(): void {
    window.localStorage.removeItem(LOCALSTORAGE_USER_ACCOUNT_SETUP_DETAILS_KEY);
  }

  getUserAuthorizationDetails(): any | null {
    const config = window.localStorage.getItem(LOCALSTORAGE_USER_AUTHORIZATION_DETAILS_KEY);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setUserAuthorizationDetails(data: any): void {
    window.localStorage.setItem(LOCALSTORAGE_USER_AUTHORIZATION_DETAILS_KEY, JSON.stringify(data));
  }

  removeUserAuthorizationDetails(): void {
    window.localStorage.removeItem(LOCALSTORAGE_USER_AUTHORIZATION_DETAILS_KEY);
  }

  clear() {
    window.localStorage.clear();
  }

  setBulkDownloadArchiveBatchSettings(data) {
    window.localStorage.setItem(BULK_DOWNLOAD_ARCHIVE_BATCH_SETTINGS, JSON.stringify(data));
  }

  removeBulkDownloadArchiveBatchSettings() {
    window.localStorage.removeItem(BULK_DOWNLOAD_ARCHIVE_BATCH_SETTINGS);
  }

  getBulkDownloadArchiveBatchSettings() {
    const config = window.localStorage.getItem(BULK_DOWNLOAD_ARCHIVE_BATCH_SETTINGS);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  // 
  setDashboardEmailNotificationSettings(data) {
    window.localStorage.setItem(DASHBOARD_EMAIL_NOTIFICATION_SETTINGS, JSON.stringify(data));
  }

  removeDashboardEmailNotificationSettings() {
    window.localStorage.removeItem(DASHBOARD_EMAIL_NOTIFICATION_SETTINGS);
  }

  getDashboardEmailNotificationSettings() {
    const config = window.localStorage.getItem(DASHBOARD_EMAIL_NOTIFICATION_SETTINGS);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }



  // 
  setBulkEngineState(data: any): void {
    window.localStorage.setItem(BULK_ENGINE_STATE, JSON.stringify(data));
  }

  getBulkEngineState() {
    const config = window.localStorage.getItem(BULK_ENGINE_STATE);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  removeBulkEngineState() {
    window.localStorage.removeItem(BULK_ENGINE_STATE);
  }



  getDashboardAggregate(): any | null {
    const config = window.localStorage.getItem(LOCALSTORAGE_DASHBOARD_AGGREGATE_KEY);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setDashboardAggregate(data: any): void {
    window.localStorage.setItem(LOCALSTORAGE_DASHBOARD_AGGREGATE_KEY, JSON.stringify(data));
  }

  removeDashboardAggregate(): void {
    window.localStorage.removeItem(LOCALSTORAGE_DASHBOARD_AGGREGATE_KEY);
  }

  // 
  getDashboardPaymentsMadeByProjects(): any | null {
    const config = window.localStorage.getItem(LOCALSTORAGE_DASHBOARD_PAYMENTS_MADE_PROJECTS_KEY);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setDashboardPaymentsMadeByProjects(data: any): void {
    window.localStorage.setItem(LOCALSTORAGE_DASHBOARD_PAYMENTS_MADE_PROJECTS_KEY, JSON.stringify(data));
  }

  removeDashboardPaymentsMadeByProjects(): void {
    window.localStorage.removeItem(LOCALSTORAGE_DASHBOARD_PAYMENTS_MADE_PROJECTS_KEY);
  }

  // 
  getDashboardPrintedByProjects(): any | null {
    const config = window.localStorage.getItem(LOCALSTORAGE_DASHBOARD_PRINTED_BY_PROJECTS_KEY);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setDashboardPrintedByProjects(data: any): void {
    window.localStorage.setItem(LOCALSTORAGE_DASHBOARD_PRINTED_BY_PROJECTS_KEY, JSON.stringify(data));
  }

  removeDashboardPrintedByProjects(): void {
    window.localStorage.removeItem(LOCALSTORAGE_DASHBOARD_PRINTED_BY_PROJECTS_KEY);
  }

  // 
  getDashboardCapturedByProjects(): any | null {
    const config = window.localStorage.getItem(LOCALSTORAGE_DASHBOARD_CAPTURED_BY_PROJECTS_KEY);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setDashboardCapturedByProjects(data: any): void {
    window.localStorage.setItem(LOCALSTORAGE_DASHBOARD_CAPTURED_BY_PROJECTS_KEY, JSON.stringify(data));
  }

  removeDashboardCapturedByProjects(): void {
    window.localStorage.removeItem(LOCALSTORAGE_DASHBOARD_CAPTURED_BY_PROJECTS_KEY);
  }

  // 
  getDashboardIssuedByProjects(): any | null {
    const config = window.localStorage.getItem(LOCALSTORAGE_DASHBOARD_ISSUED_BY_PROJECTS_KEY);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setDashboardIssuedByProjects(data: any): void {
    window.localStorage.setItem(LOCALSTORAGE_DASHBOARD_ISSUED_BY_PROJECTS_KEY, JSON.stringify(data));
  }

  removeDashboardIssuedByProjects(): void {
    window.localStorage.removeItem(LOCALSTORAGE_DASHBOARD_ISSUED_BY_PROJECTS_KEY);
  }

  // 
  getDashboardStatData(): any | null {
    const config = window.localStorage.getItem(LOCALSTORAGE_DASHBOARD_STAT_DATA_KEY);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  setDashboardStatData(data: any): void {
    window.localStorage.setItem(LOCALSTORAGE_DASHBOARD_STAT_DATA_KEY, JSON.stringify(data));
  }

  removeDashboardStatData(): void {
    window.localStorage.removeItem(LOCALSTORAGE_DASHBOARD_STAT_DATA_KEY);
  }

}
